<template>
    <v-ons-page>
        <div class="header">
            <img src="../assets/hynds-vip.svg" width="140px">
        </div>

        <div v-show="loading" class="page-progress-loader">
            <v-ons-progress-circular
                indeterminate
                ></v-ons-progress-circular>
        </div>
        <div v-show="!loading">

            <h2>Reset Your Password</h2>

            <v-ons-list v-show="stage == 'retrieve'" modifier="noborder" class="form">
                <v-ons-list-item modifier="nodivider">
                    <label for="email">Email</label>
                    <v-ons-input
                        input-id="email"
                        placeholder=""
                        v-model="profile.email"
                        type="email"
                        ></v-ons-input>
                    <p class="form-text">
                        Please enter your email to receive a reset code.
                    </p>
                </v-ons-list-item>
                <v-ons-list-item modifier="nodivider">
                    <button type="submit"
                        @click="sendCode"
                        class="button button--primary">
                        Send Code
                    </button>
                     <v-ons-button
                        @click="$router.push({ name: 'login' })"
                        modifier="cta">
                        Back to login
                    </v-ons-button>
                </v-ons-list-item>
            </v-ons-list>
            <v-ons-list v-show="stage == 'verify'" modifier="noborder" class="login-form">
                <v-ons-list-item modifier="nodivider">
                    <label for="email">Auth Code</label>
                    <v-ons-input
                        input-id="code"
                        placeholder=""
                        v-model="profile.code"
                        type="email"
                        ></v-ons-input>
                    <p class="form-text">
                        Please enter the 6-digit code sent to your email.
                    </p>
                </v-ons-list-item>
                <v-ons-list-item modifier="nodivider">
                    <button type="submit"
                        @click="verifyCode"
                        class="button button--primary">
                        Verify Code
                    </button>
                     <v-ons-button
                        @click="$router.push({ name: 'login' })"
                        modifier="cta">
                        Back to login
                    </v-ons-button>
                </v-ons-list-item>
            </v-ons-list>
            <v-ons-list v-show="stage == 'reset'" modifier="noborder" class="login-form">
                <v-ons-list-item modifier="nodivider">
                    <label for="email">New Password</label>
                    <v-ons-input
                        input-id="password"
                        placeholder=""
                        v-model="profile.password"
                        type="password"
                        ></v-ons-input>
                </v-ons-list-item>
                <v-ons-list-item modifier="nodivider">
                    <label for="password">Confirm Password</label>
                    <v-ons-input
                        input-id="confirmPassword"
                        placeholder=""
                        v-model="profile.confirmPassword"
                        type="password"
                        ></v-ons-input>
                    <p class="form-text">
                        Min 8 characters, one UPPERCASE letter and one number.
                    </p>
                </v-ons-list-item>
                <v-ons-list-item modifier="nodivider">
                    <button type="submit"
                        @click="save"
                        class="button button--primary">
                        Save
                    </button>
                     <v-ons-button
                        @click="$router.push({ name: 'login' })"
                        modifier="cta">
                        Back to login
                    </v-ons-button>
                </v-ons-list-item>
            </v-ons-list>
        </div>
    </v-ons-page>
</template>

<script>
import Utils from './mixins/Utils'
import Module from './mixins/Module'

export default {
    data() {
        return {
            loading: false,
            stage: 'retrieve',
            profile: {
                email: '',
                password: '',
                confirmPassword: '',
            }
        }
    },

    created() {
        this.$emit('init', {
            name: 'reset-password',
            title: 'reset Password',
            showMenu: false,
        })
    },

    mixins: [
        Utils,
        Module('login'),
        Module('customer'),
    ],

    methods: {
        save() {
            if (!this.profile.password) {
                return this.notification_push({
                    type: 'error',
                    message: 'Please enter your new password',
                })
            }

            if (this.profile.password !== this.profile.confirmPassword) {
                return this.notification_push({
                    type: 'error',
                    message: `Confirm password doesn't match`,
                })
            }

            this.loading = true
            this.api.putData('/my/password', {}, {
                ...this.profile,
            }).then((res) => {
                this.profile.password = ''
                this.profile.confirmPassword = ''
                this.notification_push({
                    type: 'success',
                    message: 'Your password has been updated',
                })
                this.signin(res)
                this.$router.push({ name: 'home' })
            }).catch((err) => {
                this.notification_push({
                    type: 'error',
                    message: _.get(err, 'response.data.message', `Sorry, we couldn't update your password.`),
                })
            }).finally(() => {
                this.loading = false
            })
        },

        sendCode(e) {
            this.loading = true
            this.api.postData('/my/authCode', {}, {
                email: this.profile.email,
            }).then(res => {
                this.stage = 'verify'
                this.notification_push({
                    type: 'success',
                    message: 'Done! Please check your email for the reset code',
                })
            }).catch(err => {
                this.notification_push({
                    type: 'error',
                    message: _.get(err, 'response.data.message', 'An error occured. Please try again.'),
                })
            }).finally(() => {
                this.loading = false
            })
        },

        verifyCode(e) {
            this.loading = true
            this.api.getData('/my/authCode', {
                ...this.profile,
            }).then(res => {
                this.stage = 'reset'
                // this.notification_push({
                    // type: 'success',
                    // message: 'Done! Please check your email for reset code',
                // })
            }).catch(err => {
                this.notification_push({
                    type: 'error',
                    message: _.get(err, 'response.data.message', 'An error occured. Please try again.'),
                })
            }).finally(() => {
                this.loading = false
            })
        },

        signin(login) {
            this.login.setContent(login);
            this.customer.setContent(_.get(login, 'included.parent', {}));
            window.localStorage.setItem('login', JSON.stringify(login));
            this.setToken(login.token);
        },
    }
};
</script>

<style scoped>
.header {
    text-align: center;
    padding: 5rem 0 1rem 0 !important;
}
.list-item{
    padding: 0 14px;
}
ons-input {
    width: 100%;
}
img {
    max-width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/ResetPassword.vue